import { render, staticRenderFns } from "./CardTotalRun.vue?vue&type=template&id=8d852982&scoped=true&"
import script from "./CardTotalRun.vue?vue&type=script&lang=js&"
export * from "./CardTotalRun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d852982",
  null
  
)

export default component.exports